export default __webpack_public_path__ + "static/media/fortune black 1.787313c7.svg";